// removed by extract-text-webpack-plugin
module.exports = {"root":"_gFPPX","pictureGroups":"_24i6t","picture":"_2QCnd"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/LiveSection/components/LiveCarousel/LiveCarousel.scss
// module id = 1334
// module chunks = 3